import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

function SingleSelect({
  options,
  handleChange,
  label,
  displayAttribute,
  selectAttribute,
  testId,
  ...rest
}) {
  return (
    <Autocomplete
      test-id={`singleSelect${testId}`}
      options={options}
      getOptionLabel={(option) => option?.[displayAttribute]}
      renderOption={(props, option) => <li {...props}>{option[displayAttribute]}</li>}
      onChange={handleChange}
      renderInput={(params) => <TextField {...params} variant="outlined" />}
      {...rest}
    />
  );
}

SingleSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  displayAttribute: PropTypes.string.isRequired,
  selectAttribute: PropTypes.string.isRequired,
  testId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default SingleSelect;
